export const ModalitePedagogique = ['Presentielle', 'Mixte', 'Distance', 'Afest'] as const
export type ModalitePedagogique = (typeof ModalitePedagogique)[number]

export const ModalitePedagogiqueLibelle: { [key in ModalitePedagogique]: string } = {
  Presentielle: 'Présentielle',
  Mixte: 'Mixte',
  Distance: 'A Distance',
  Afest: 'AFEST'
} as const
